// Identify a website to offer for review. This never fetches the URL; the
// existing server-side import validation remains authoritative.
export function websiteMention(text: string): string | null {
  const match = text.match(/(?:https?:\/\/|www\.)[^\s<>"']+|(?<![@\w])(?:[a-z0-9-]+\.)+[a-z]{2,}(?:\/[^\s<>"']*)?/i)?.[0].replace(/[.,;!?]+$/, "");
  if (!match) return null;
  try { const url=new URL(/^https?:\/\//i.test(match) ? match : `https://${match}`); return ["http:","https:"].includes(url.protocol) && url.hostname.includes(".") ? match : null; }
  catch { return null; }
}
export function websiteKey(value: string): string {
  try { const url=new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`); return `${url.hostname.toLowerCase().replace(/^www\./,"")}${url.pathname.replace(/\/+$/,"")}`; }
  catch { return ""; }
}
